/*
 * @author: linbenjian
 * @date: 2018-07-13 14:13:07
 */

import React from 'react';
import PropTypes from 'prop-types';
import './empty.less';
const EmptyPng = require('./empty.png');
export default function SearchEmptyTips(props) {
  return (
    <div className="search-empty">
      <img src={EmptyPng} width="75px" height="59px" />
      <span className="empty-tips-text">
        抱歉！暂未找到与“
        {props.keyword}
        ”相关的案例
      </span>
    </div>
  );
}
SearchEmptyTips.propTypes = {
  keyword: PropTypes.string,
};
